import { LocalAudioTrack } from 'twilio-video';
import { useCallback, useRef } from 'react';
import { useAppState } from '../../state';
import useVideoContext from '../useVideoContext/useVideoContext';

export function useKrispToggle() {
	const { localTracks, onError } = useVideoContext();
	const audioTrack = localTracks.find(
		(track) => track.kind === 'audio',
	) as LocalAudioTrack;
	const noiseCancellation = audioTrack && audioTrack.noiseCancellation;
	const vendor = noiseCancellation && noiseCancellation.vendor;
	const { setIsKrispEnabled } = useAppState();

	const pending = useRef(false);
	const toggleKrisp = useCallback(() => {
		if (noiseCancellation && !pending.current) {
			pending.current = true;
			noiseCancellation[
				noiseCancellation.isEnabled ? 'disable' : 'enable'
			]()
				.then(() => {
					if (!audioTrack.isStopped)
						setIsKrispEnabled(noiseCancellation.isEnabled);
				})
				.catch(() =>
					onError(
						new Error(
							'Unable to change noise cancellation. Please try again.',
						),
					),
				)
				.finally(() => {
					pending.current = false;
				});
		}
	}, [noiseCancellation, audioTrack, setIsKrispEnabled, onError]);

	return { vendor, toggleKrisp };
}
